import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	bulkDeleteDepots,
	bulkDeleteDepotsFail,
	bulkDeleteDepotsSuccess,
	changeVersionForSelectedDataLinkRepo,
	changeVersionForSelectedDataLinkRepoFail,
	changeVersionForSelectedDataLinkRepoSuccess,
	createEntityFromDepot,
	createEntityFromDepotFail,
	createEntityFromDepotSuccess,
	deleteDepot,
	deleteDepotFail,
	deleteDepotSuccess,
	fetchAvailableVersionForSelectedDataLinkRepoSuccess,
	fetchDepotHeadersFail,
	fetchDepotHeadersSuccess,
	fetchDepotListFail,
	fetchDepotListSuccess,
	fetchDepotSchemaMappingSuccess,
	getDepotHeaderSettingSuccess,
	initAvailableDepotHeadersForEntityCreation,
	initDepotList,
	openDepotHeaderFieldsSelection,
	reconstructDepotSchemaMappingSuccess,
	refreshDepotList,
	replaceCurrentLabelWith,
	resetAvailableHeaders,
	triggerDetectAvailableHeaders,
	updateEntitiesCountForDepotSuccess,
} from './depot.actions';
import { DepotOriginalSliceState } from './depot.state';

export const depotOriginalReducer = createReducer<DepotOriginalSliceState>(
	new DepotOriginalSliceState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initDepotList, refreshDepotList, createEntityFromDepot, (state) =>
		state.setLoading(true)
	),
	on(
		fetchDepotListFail,
		createEntityFromDepotSuccess,
		createEntityFromDepotFail,
		(state) => state.setLoading(false)
	),
	on(fetchDepotListSuccess, (state, action) =>
		state.setLoading(false).setDepotList(action.depotList)
	),
	on(initAvailableDepotHeadersForEntityCreation, (state) =>
		state.setLoading(true)
	),
	on(resetAvailableHeaders, (state) => state.deleteHeadersForState()),
	on(fetchDepotHeadersSuccess, (state, action) =>
		state
			.setLoading(false)
			.setAvailableCharacteristicTypes(action.availableCharacteristicTypes)
			.setAvailableDateFormats(action.availableDateFormats)
			.setAvailableTimezones(action.availableTimezones)
			.setSupportedLanguages(action.supportedLanguages)
			.setHeadersForSelectRepo(action.headers)
	),
	on(fetchDepotHeadersFail, (state) => state.setLoading(false)),
	on(openDepotHeaderFieldsSelection, triggerDetectAvailableHeaders, (state) =>
		state.setDepotSchema(null)
	),
	on(
		fetchDepotSchemaMappingSuccess,
		reconstructDepotSchemaMappingSuccess,
		(state, action) => state.setDepotSchema(action.mapping)
	),
	on(replaceCurrentLabelWith, (state, action) => {
		if (state.depotSchema !== null) {
			const updated = state.depotSchema.map((c) =>
				c.replaceWith(action.searchTerm, action.replaceWith)
			);
			return state.setDepotSchema(updated);
		}
		return state;
	}),
	on(updateEntitiesCountForDepotSuccess, (state, action) =>
		state.setDepotList(action.depotList)
	),
	on(deleteDepot, bulkDeleteDepots, (state) => state.setActionInProgress(true)),
	on(
		deleteDepotSuccess,
		deleteDepotFail,
		bulkDeleteDepotsSuccess,
		bulkDeleteDepotsFail,
		(state) => state.setActionInProgress(false)
	),
	on(getDepotHeaderSettingSuccess, (state, action) =>
		state
			.setAvailableCharacteristicTypes(action.availableCharacteristicTypes)
			.setAvailableDateFormats(action.availableDateFormats)
			.setAvailableTimezones(action.availableTimezones)
			.setSupportedLanguages(action.supportedLanguages)
	),
	on(fetchAvailableVersionForSelectedDataLinkRepoSuccess, (state, action) =>
		state.setAvailableVersionsForSelectDataLinkRepo(action.versions)
	),
	on(changeVersionForSelectedDataLinkRepo, (state) => state.setLoading(true)),
	on(
		changeVersionForSelectedDataLinkRepoSuccess,
		changeVersionForSelectedDataLinkRepoFail,
		(state) => state.setLoading(false)
	)
);
